<template>
  <div class="inpBox">
    <div class="detailsTitle">
      <h4>找车提货</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules" class="demo-form-inline jiaoyan" label-width="140px" size="mini">
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
          <el-form-item class="is-required" label="发货人:" prop="deliverPerson" label-width="80px">
            <el-input placeholder="请选择发货人" class="disabled" maxlength="10" :readonly="true" v-model="goodform.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:" class="is-required" prop="deliverPhone">
            <el-input placeholder="请选择发货人电话" class="disabled" maxlength="11" :readonly="true" type="tel" v-model="goodform.deliverPhone"></el-input>
          </el-form-item>
          <!-- <div> -->
          <el-form-item label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true" v-model="goodform.deliverAddress"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="addxzdzFn(2)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>地址簿</el-button>
          </el-form-item>
          <!-- </div> -->
        </div>
        <div>
          <el-form-item label="收货人:" prop="receivingPerson" label-width="80px">
            <el-input placeholder="请选择收货人" class="disabled" maxlength="10" :readonly="true" v-model="goodform.receivingPerson"></el-input>
          </el-form-item>
          <el-form-item label="收货人电话:" prop="receivingPhone">
            <el-input placeholder="请选择收货人电话" class="disabled" maxlength="11" :readonly="true" type="tel" v-model="goodform.receivingPhone"></el-input>
          </el-form-item>
          <!-- <div> -->
          <el-form-item label="收货地址:" prop="receivingAddress" class="diqu1">
            <el-input placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true" v-model="goodform.receivingAddress"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="addxzdzFn(1)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>地址簿</el-button>
          </el-form-item>
          <!-- </div> -->
        </div>
      </div>
      <hr>

      <div>
        <div class="demo-form-inline jiaoyan1">
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
              <span class="searchBtnBox">
                <span class="styl">总件数：<span class="red">{{allNum}}</span>件</span>
                <span class="styl">总重量：<span class="red">{{Number(this.toFixed(allWeight,3))}}</span>吨</span>
              </span>
            </h4>
          </div>
          <el-table :data="goodform.options" ref="table" bordersize="mini" style="width: 100%" height="300" border center>
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column label="货物类型" min-width="170" prop="productTypeName"></el-table-column>
            <el-table-column label="产地" min-width="170" prop="steelMillName"></el-table-column>
            <el-table-column label="规格" min-width="170" prop="specification"></el-table-column>
            <el-table-column label="材质" min-width="170" prop="model"></el-table-column>
            <el-table-column label="件数" min-width="170" prop="planNum"></el-table-column>
            <el-table-column label="重量(吨)" min-width="170" prop="planWeight"></el-table-column>
          </el-table>
        </div>

      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>竞价要求</span>
        </h4>
        <div>
          <el-form-item label="竞价方式:" prop="demandType" class="ziti">
            <el-radio-group v-model="goodform.demandType" @change="rangeChange">
              <el-radio :label="1">竞价</el-radio>
              <el-radio :label="2">抢单</el-radio>
              <el-radio :label="3">指派</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="goodform.demandType == 1">

            <el-form-item label="报价方式:" prop="pricingMethod" class="jiage">
              <el-select v-model="goodform.pricingMethod" placeholder="请选择" @change="priceChange">
                <el-option v-for="val in pricingMethods" :label="val.name" :value="val.val" :key="val.val"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="限价区间(不含税):" label-width="200px" class="jiage1" v-if="goodform.pricingMethod==1">
              <div class="price">
                <el-form-item label="" prop="lowPrice">
                  <el-input placeholder="最低限价" v-number-input.float="2" maxlength="8" v-model="goodform.lowPrice"></el-input><span class="danwei1">元/吨</span>
                </el-form-item>
                ~&nbsp;
                <!-- <el-form-item label="" prop="highPrice" >
                <el-input  placeholder="最高限价"  v-number-input.float="2" @blur = p($event.target.value)  maxlength="8" v-model="goodform.highPrice"></el-input><span class="danwei2">元/吨</span>
              </el-form-item> -->
                <el-form-item label="" prop="highPrice">
                  <el-input placeholder="最高限价" v-number-input.float="2" maxlength="8" v-model="goodform.highPrice"></el-input><span class="danwei2">元/吨</span>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="限价区间(不含税):" label-width="200px" class="jiage1" v-if="goodform.pricingMethod==2">
              <div class="price">
                <el-form-item label="" prop="lowPrice">
                  <el-input placeholder="最低限价" v-number-input.float="2" maxlength="8" v-model="goodform.lowPrice"></el-input><span class="danwei1">元</span>
                </el-form-item>
                ~&nbsp;
                <el-form-item label="" prop="highPrice">
                  <el-input placeholder="最高限价" v-number-input.float="2" maxlength="8" v-model="goodform.highPrice"></el-input><span class="danwei2">元</span>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="杂费:" prop="incidental" class="jiage">
              <el-input placeholder="杂费" v-number-input.float="2" maxlength="8" v-model="goodform.incidental"></el-input><span class="danwei1">元</span>
            </el-form-item>

            <div>
              <el-form-item label="合计:" v-if="goodform.pricingMethod==1">
                <el-button type="text" @click="totalFN"><span style="font-size:14px">{{addUp1|numFormat(2)}}元 ~ {{addUp2|numFormat(2)}}元</span></el-button>
              </el-form-item>
              <el-form-item label="合计:" v-if="goodform.pricingMethod==2">
                <el-button type="text" @click="totalFN"><span style="font-size:14px">{{BGaddUp1|numFormat(2)}}元 ~ {{BGaddUp2|numFormat(2)}}元</span></el-button>
              </el-form-item>
            </div>

            <el-form-item label="发布范围:" prop="publishScopeType" class="ziti">
              <label slot="label"><span style="color:red">*</span>发布范围:</label>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="selectFleetFn">选择</el-button>
            </el-form-item>
            <div style="margin-left:130px;margin-bottom:20px" v-if="multipleSelection!=0">
              <el-tag v-for="(tag,index) in multipleSelection" :key="index" closable :disable-transitions="false" @close="handleClose(tag)">
                {{tag.targetTenantName}}
              </el-tag>
            </div>
            <div>
              <!-- <el-form-item label="竞价有效期至:" prop="demandFinalDate" >
              <el-date-picker
                v-model="goodform.demandFinalDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                placeholder="选择日期时间"
                :picker-options="pickerOptions"></el-date-picker>
            </el-form-item> -->
              <el-form-item label="竞价有效期至:" prop="demandFinalDate">
                <el-date-picker v-model="goodform.demandFinalDate" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间" @change="RchangeDateFn"></el-date-picker>
              </el-form-item>
            </div>
            <div v-if="goodform.triggerStatus == true">
              <el-form-item label="发布时间点(时):" prop="triggerStartDate">
                <!-- <el-time-picker
                  v-model="goodform.triggerStartDate"
                  format="HH"
                  value-format="HH"
                  placeholder="选择时间"
                ></el-time-picker> -->
                <el-select v-model="goodform.triggerStartDate" placeholder="请选择">
                  <el-option v-for="val in status1" :label="val.name" :value="val.name" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="报价有效时长:" prop="triggerDuration" class="jiage">
                <el-input placeholder="" v-number-input.float="0" @blur="effectiveTime()" maxlength="8" v-model.trim="goodform.triggerDuration"></el-input><span class="danwei">小时</span>
              </el-form-item>
              <el-form-item label="循环结束日期:" prop="triggerEndDate" label-width="168px">
                <el-date-picker v-model="goodform.triggerEndDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions1"></el-date-picker>
              </el-form-item>
            </div>
          </div>

          <div v-if="goodform.demandType == 2">
            <div>
              <el-form-item label="计价方式:" prop="pricingMethod" class="jiage">
                <el-select v-model="goodform.pricingMethod" placeholder="请选择" @change="priceChange">
                  <el-option v-for="val in pricingMethods" :label="val.name" :value="val.val" :key="val.val"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单价(不含税):" class="jiage" prop="unitPrice" v-if="goodform.pricingMethod==1" label-width="157px">
                <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="goodform.unitPrice"></el-input><span class="danwei">元/吨</span>
              </el-form-item>
              <el-form-item label="包干价(不含税):" class="jiage" prop="unitPrice" v-if="goodform.pricingMethod==2" label-width="157px">
                <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="goodform.unitPrice"></el-input><span class="danwei">元</span>
              </el-form-item>
              <el-form-item label="杂费:" prop="incidental" class="jiage">
                <el-input placeholder="杂费" v-number-input.float="2" maxlength="8" v-model="goodform.incidental"></el-input><span class="danwei1">元</span>
              </el-form-item>
              <div>
                <el-form-item label="运费:" class="jiage" v-if="goodform.pricingMethod==1">
                  <span class="red">{{expenses|numFormat(2)}}</span>元
                </el-form-item>
                <el-form-item label="运费:" class="jiage" v-if="goodform.pricingMethod==2">
                  <span class="red">{{goodform.unitPrice ? goodform.unitPrice : 0.00|numFormat(2)}}</span>元
                </el-form-item>
                <el-form-item label="找车服务费:" class="jiage">
                  <span class="red">{{this.serviceFee|numFormat(2)}}</span>元
                </el-form-item>
                <el-form-item label="合计费用:" class="mar10" v-if="goodform.pricingMethod==1">
                  <span class="red">{{allP1|numFormat(2)}}</span>元
                </el-form-item>
                <el-form-item label=" 合计费用:" class="mar10" v-if="goodform.pricingMethod==2">
                  <span class="red">{{allP2|numFormat(2)}}</span>元
                </el-form-item>
                <el-form-item label="" class="mar10">
                  <span class="red">（注：合计费用=运费+找车服务费+杂费）</span>
                </el-form-item>
              </div>
              <div>
                <!-- <el-form-item label="加价间隔时间:" prop="markupInterval" class="jiage">
                <el-input  placeholder="1-60分钟" v-number-input.float="0" @blur= effectiveTime()  maxlength="2" v-model.trim="goodform.markupInterval" ></el-input><span class="danwei">分钟</span>
              </el-form-item> -->
                <el-form-item label="加价间隔时间(分钟):" prop="markupInterval">
                  <el-select v-model="goodform.markupInterval" placeholder="请选择">
                    <el-option v-for="val in status" :label="val.name" :value="val.name" :key="val.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="goodform.markupInterval" label="加价间隔金额:" prop="markupAmount" class="jiage" label-width="158px">
                  <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="goodform.markupAmount"></el-input><span class="danwei">元</span>
                </el-form-item>
                <el-form-item v-if="goodform.markupInterval && goodform.markupAmount" label="最高限价:" prop="markupHighAmount" class="jiage">
                  <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="goodform.markupHighAmount"></el-input><span class="danwei">元</span>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="发布范围:" prop="publishScopeType" class="ziti">
              <label slot="label"><span style="color:red">*</span>发布范围:</label>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="selectFleetFn">选择</el-button>
            </el-form-item>
            <div style="margin-left:130px;margin-bottom:20px" v-if="multipleSelection!=0">
              <el-tag v-for="tag in multipleSelection" :key="tag.id" closable :disable-transitions="false" @close="handleClose(tag)">
                {{tag.targetTenantName}}
              </el-tag>
            </div>
            <div>
              <el-form-item label="抢单有效期至:" prop="demandFinalDate">
                <el-date-picker v-model="goodform.demandFinalDate" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间" @change="RchangeDateFn"></el-date-picker>
              </el-form-item>
              <!-- <el-checkbox v-model="goodform.triggerStatus">是否每日定时发布</el-checkbox> -->
            </div>
            <div v-if="goodform.triggerStatus == true">
              <el-form-item label="发布时间点(时):" prop="triggerStartDate">
                <!-- <el-time-picker
                  v-model="goodform.triggerStartDate"
                  format="HH"
                  value-format="HH"
                  placeholder="选择时间"
                ></el-time-picker> -->
                <el-select v-model="goodform.triggerStartDate" placeholder="请选择">
                  <el-option v-for="val in status1" :label="val.name" :value="val.name" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="抢单有效时长:" prop="triggerDuration" class="jiage">
                <el-input placeholder="" v-number-input.float="0" @blur="effectiveTime()" maxlength="8" v-model.trim="goodform.triggerDuration"></el-input><span class="danwei">小时</span>
              </el-form-item>
              <el-form-item label="循环结束日期:" prop="triggerEndDate" label-width="168px">
                <el-date-picker v-model="goodform.triggerEndDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions1"></el-date-picker>
              </el-form-item>
            </div>
          </div>

          <div v-if="goodform.demandType == 3">
            <el-form-item label="指派承运方:" prop="publishScopeType" class="ziti">
              <label slot="label"><span style="color:red">*</span>指派承运方:</label>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="selectFleetFn">选择</el-button>
            </el-form-item>
            <div style="margin-left:130px;margin-bottom:20px" v-if="multipleSelection!=0">
              <el-tag v-for="(tag,index) in multipleSelection" :key="index" closable :disable-transitions="false" @close="handleClose(tag)">
                {{tag.targetTenantName}}
              </el-tag>
            </div>
            <!-- <div> -->
            <el-form-item label="指派有效期至:" prop="demandFinalDate">
              <el-date-picker v-model="goodform.demandFinalDate" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间" @change="RchangeDateFn"></el-date-picker>
            </el-form-item>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>
          <div>
            <el-form-item label="已购货险:" prop="isInsurance" class="ziti">
              <el-radio-group v-model="goodform.isInsurance">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <div style="display: inline-block;" v-if="goodform.isInsurance==1">
              <el-form-item label="保险单号:" prop="insuranceNo" label-width="180px" class="inpBox1">
                <el-input placeholder="" maxlength="30" v-model="goodform.insuranceNo"></el-input>
              </el-form-item>
              <el-form-item label="保险公司:" prop="insuranceCompany" label-width="131px">
                <el-input placeholder="" maxlength="20" v-model="goodform.insuranceCompany"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="外部单号:" prop="outBillNo">
            <el-input placeholder="" maxlength="20" v-model="goodform.outBillNo"></el-input>
          </el-form-item>
          <el-form-item label="最晚提货时间:" prop="hopeReceivingDate" label-width="137px">
            <el-date-picker v-model="goodform.hopeReceivingDate" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间" @change="RchangeDateFn"></el-date-picker>
          </el-form-item>
          <div>
            <div>
              <el-form-item label="能源类型:" prop="energyName">
                <el-select placeholder="请选择" v-model="goodform.energyName" filterable multiple @change="energyTypeChange">
                  <el-option v-for="item in energyTypeOptions" :key="item.id" :label="item.energyName" :value="item.energyName"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="能源类型:" prop="energyName">
              <el-select placeholder="请选择" v-model="goodform.energyName" filterable multiple>
                <el-option v-for="item in energyTypeOptions" :key="item.id" :label="item.energyName"  :value="item.energyName"></el-option>
              </el-select>
            </el-form-item> -->
              <el-form-item label="排放标准:" prop="standardsName" label-width="138px" class="inpBox1">
                <el-select placeholder="请选择" v-model="goodform.standardsName" filterable multiple @change="standardsChange">
                  <el-option v-for="item in pfbz" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运输要求:" prop="transInfo" class="inpBox3">
                <el-input placeholder="" maxlength="50" v-model="goodform.transInfo"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="备注信息:" class="remark" prop="remark">
              <el-input placeholder="" type="textarea" rows="4" style="width:930px;" maxlength="200" v-model="goodform.remark"></el-input>
            </el-form-item>
          </div>
          <div class="imgBox">
            <el-upload action="/stock/sBill/addFiles" ref="upload" :headers="header" :auto-upload=false :multiple=true :on-change="imgPreview" list-type="picture-card" accept="image/*" :limit="20" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :class="[isAdd?'hidden':'']">
            </el-upload>
            <span style="font-size:12px">最多上传5张，支持jpg、png格式图片</span>
            <el-dialog title="图片展示" :visible.sync="dialogVisible" center>
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div class="shuoming">
            <el-form-item>
              <el-checkbox v-model="islook">
                <el-button type="text" size="mini" @click="shuomingFn"><span style="font-size:16px">我已知晓【找车说明】</span></el-button>
              </el-checkbox>
            </el-form-item>
          </div>

        </div>
      </div>
    </el-form>
    <div class="footerBtn">
      <!-- <el-button class="bigBtn"  @click="resetForm('goodform')">取消</el-button> -->
      <el-button type="primary" class="bigBtn" @click="saveFn('goodform')" :loading="fbLoad">发布</el-button>
    </div>
    <!-- 选择地址 -->
    <selectAddress :type="addressType" v-if="dialogXzdz" @handleCurrentChange="handleCurrentChange" @destroy="destroy"></selectAddress>
    <!-- 预计费用明细 -->
    <el-dialog title="预计费用明细" :visible.sync="charge" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="800px" center>
      <div style="height:300px;margin-top:20px">
        <table border="1" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <td>限价区间</td>
              <td>限价总价(元)</td>
              <td>找车服务费(含税/元)</td>
              <td>杂费(元)</td>
              <td>合计(元)</td>
            </tr>
          </thead>
          <tbody v-if="this.goodform.pricingMethod == 1">
            <tr>
              <td>最低限价</td>
              <td>{{lowTotalPrice}}</td>
              <td>{{this.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(addUp1,2))}}</td>
            </tr>
            <tr>
              <td>最高限价</td>
              <td>{{highTotalPrice}}</td>
              <td>{{this.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(addUp2,2))}}</td>
            </tr>
          </tbody>
          <tbody v-if="this.goodform.pricingMethod == 2">
            <tr>
              <td>最低限价</td>
              <td>{{goodform.lowPrice}}</td>
              <td>{{this.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(BGaddUp1,2))}}</td>
            </tr>
            <tr>
              <td>最高限价</td>
              <td>{{goodform.highPrice}}</td>
              <td>{{this.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(BGaddUp2,2))}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="charge = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 选择车队 -->
    <el-dialog title="选择车队" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="isEdit" @close="closeDialog" width="1100px" center>
      <div>
        <div class="spry">
          <div class="tbox">
            <el-table :data="sDemandOfferList" :row-key="getRowKeys" border ref="CDtable" highlight-current-row @selection-change="handleSelectionChange" max-height="350px">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" prop="date" width="55" :reserve-selection="true" label="序号"></el-table-column>
              <el-table-column prop="targetTenantName" min-width="190px" :formatter="emptyFn" label="车队名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="goodsTypeNames" min-width="160px" :formatter="emptyFn" label="偏好货物" show-overflow-tooltip></el-table-column>
              <el-table-column prop="vehicleNum" width="120px" :formatter="emptyFn" label="车辆数"></el-table-column>
              <el-table-column prop="driverNum" width="120px" :formatter="emptyFn" label="司机人数"></el-table-column>
              <el-table-column prop="areaNames" min-width="300px" :formatter="emptyFn" label="偏好路线" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>
        <div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isEdit = false">取消</el-button>
        <el-button type="primary" @click="fleetFN()">确定</el-button>
      </span>
    </el-dialog>
    <zhaocheshuoming v-if="shuomingFlag" @destroy="destroy"></zhaocheshuoming>
  </div>
</template>

<script>
import { toFixed, emptyFn, dateTimeFormat, dateFormatUtil } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import { dropDownList, addForFindCar, addSDemandFile } from '@/api/soc-stock'
import { selectTenantLongCarriageList, cVehicleEmissionStandards, cVhcEnergyType } from '@/api/vgs-driver2.0'
import zhaocheshuoming from '@/components/networkFreight/zhaocheshuoming.vue'
import { compressImage } from '@/utils/compressImage'
import selectAddress from '@/components/networkFreight/selectAddress.vue'
import store from '@/store'
export default {
  components: {
    selectAddress,
    zhaocheshuoming
  },
  data () {
    let token = store.getUser().access_token
    return {
      status: [
        { name: '10', id: 1 },
        { name: '20', id: 2 },
        { name: '30', id: 3 },
        { name: '40', id: 4 },
        { name: '50', id: 5 },
        { name: '60', id: 6 }
      ],
      status1: [
        { name: '00:00', id: 1 },
        { name: '01:00', id: 2 },
        { name: '02:00', id: 3 },
        { name: '03:00', id: 4 },
        { name: '04:00', id: 5 },
        { name: '05:00', id: 6 },
        { name: '06:00', id: 7 },
        { name: '07:00', id: 8 },
        { name: '08:00', id: 9 },
        { name: '09:00', id: 10 },
        { name: '10:00', id: 11 },
        { name: '11:00', id: 12 },
        { name: '12:00', id: 13 },
        { name: '13:00', id: 14 },
        { name: '14:00', id: 15 },
        { name: '15:00', id: 16 },
        { name: '16:00', id: 17 },
        { name: '17:00', id: 18 },
        { name: '18:00', id: 19 },
        { name: '19:00', id: 20 },
        { name: '20:00', id: 21 },
        { name: '21:00', id: 22 },
        { name: '22:00', id: 23 },
        { name: '23:00', id: 24 }
      ],
      dateFormatUtil: dateFormatUtil,
      dateTimeFormat: dateTimeFormat,
      islook: false,
      shuomingFlag: false,
      rowSelectFlag: false,
      sDemand: {},
      sOrderProductList: [],
      productTypes: [],
      SelectionTag: [],
      multipleSelection: [],
      sDemandOfferList: [],
      isEdit: false,
      toFixed: toFixed,
      emptyFn: emptyFn,
      serviceFee: '0.00',
      billData: [],
      importDialog: false,
      pricingMethods: [
        { val: 1, name: '单价' },
        { val: 2, name: '包干' }
      ],
      energyTypeOptions: [],
      pfbz: [],
      charge: false,
      goodform: {
        options: [{
        }
        ],
        // 发布范围
        publishScopeType: '',
        // 竞价方式
        demandType: 1,
        // 计价方式
        pricingMethod: 1,
        // 已购货险
        isInsurance: 2,
        // 是否每日定时发布
        triggerStatus: false
      },
      imgList: [],
      dialogImageUrl: '',
      header: { Authorization: 'Bearer ' + token },
      dialogVisible: false,
      isAdd: false,
      dialogAddress: false,
      types: [
        { name: '收货地址', id: 1 },
        { name: '发货地址', id: 2 }
      ],
      rules: {
        // publishScopeType: [
        //   { required: true, message: '请选择发布范围', trigger: 'blur' }
        // ],
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ],
        unitPrice: [
          { required: true, message: '请输入单价或包干价', trigger: 'blur' }
        ],
        // productTypeId: [
        //   { required: true, message: '请选择货物类型', trigger: 'blur' }
        // ],
        productTypeName: [
          { required: true, message: '请选择货物类型', trigger: ['change', 'blur'] }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        hopeReceivingDate: [
          { required: true, message: '请选择最晚提货时间', trigger: 'blur' }
        ],
        triggerStartDate: [
          { required: true, message: '请选择发布时间点', trigger: 'blur' }
        ],
        demandFinalDate: [
          { required: true, message: '请选择有效期至', trigger: 'blur' }
        ],
        triggerDuration: [
          { required: true, message: '请输入有效时长', trigger: 'blur' }
        ],
        triggerEndDate: [
          { required: true, message: '请选择循环结束日期', trigger: 'blur' }
        ],
        demandType: [
          { required: true, message: '请选择竞价方式', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        lowPrice: [
          { required: true, message: '请输入最低限价', trigger: 'blur' }
        ],
        highPrice: [
          { required: true, message: '请输入最高限价', trigger: 'blur' }
        ],
        isInsurance: [
          { required: true, message: '是否已购货险', trigger: 'blur' }
        ],
        insuranceNo: [
          { required: true, message: '请输入保险单号', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '请输入保险公司', trigger: 'blur' }
        ],
        receivingPerson: [
          { required: true, message: '请选择收货人', trigger: 'blur' }
        ],
        receivingPhone: [
          { required: true, message: '请选择收货人电话', trigger: 'blur' }
        ],
        receivingAddress: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        deliverPerson: [
          { required: true, message: '请选择发货人', trigger: 'blur' }
        ],
        deliverPhone: [
          { required: true, message: '请选择发货人电话', trigger: 'blur' }
        ],
        deliverAddress: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ]
      },
      dialogXzdz: false,
      addressType: 1,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
          // return time.getTime() < new Date().getTime()
        }
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      btnFlg: [],
      btnIdArr: ['004P001B000', '004P001B001'],
      energyTypeList: [],
      emissionStandardList: [],
      allNum: 0,
      allWeight: 0,
      janFaFlag: '',
      fbLoad: false
    }
  },
  created () {
    console.log(this.$route.query.goodsList)
    this.goodform.options = this.$route.query.goodsList.goodList
    this.janFaFlag = this.$route.query.goodsList.janFaFlag
    this.allNum = this.$route.query.goodsList.allNum
    this.allWeight = this.$route.query.goodsList.allWeight
    this.btnFlg = getBtn(this.btnIdArr, '/releaseGoods')
    dropDownList().then(res => {
      this.productTypes = res
    })
    // getDemandServiceFee().then(res => {
    //   this.serviceFee = res.serviceFee
    // })
    cVehicleEmissionStandards().then(res => {
      this.pfbz = res
    })
    cVhcEnergyType().then(res => {
      this.energyTypeOptions = res
    })
  },
  watch: {

  },
  computed: {
    // 竞价
    addUp1 () {
      let total1 = 0
      if (this.goodform.lowPrice && this.allWeight) {
        total1 = parseFloat(total1) + Number(this.toFixed(parseFloat(this.goodform.lowPrice) * parseFloat(this.allWeight), 2)) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.serviceFee)
      }
      // console.log(total1)
      return total1
    },
    addUp2 () {
      let total2 = 0
      if (this.goodform.highPrice && this.allWeight) {
        total2 = parseFloat(total2) + Number(this.toFixed(parseFloat(this.goodform.highPrice) * parseFloat(this.allWeight), 2)) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.serviceFee)
      }
      // console.log(total2)
      return total2
    },
    BGaddUp1 () {
      let total1 = 0
      if (this.goodform.lowPrice) {
        total1 = parseFloat(total1) + parseFloat(this.goodform.lowPrice) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.serviceFee)
      }
      // console.log(total1)
      return total1
    },
    BGaddUp2 () {
      let total2 = 0
      if (this.goodform.highPrice) {
        total2 = parseFloat(total2) + parseFloat(this.goodform.highPrice) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.serviceFee)
      }
      // console.log(total2)
      return total2
    },
    lowTotalPrice () {
      let lowTotal = 0
      if (this.goodform.lowPrice && this.allWeight) {
        lowTotal = parseFloat(lowTotal) + Number(this.toFixed(parseFloat(this.goodform.lowPrice) * parseFloat(this.allWeight), 2))
      }
      // console.log(lowTotal)
      return lowTotal
    },
    highTotalPrice () {
      let highTotal = 0
      if (this.goodform.highPrice && this.allWeight) {
        highTotal = parseFloat(highTotal) + Number(this.toFixed(parseFloat(this.goodform.highPrice) * parseFloat(this.allWeight), 2))
      }
      // console.log(highTotal)
      return highTotal
    },
    // 抢单
    expenses () {
      let lowTotal = 0
      if (this.goodform.unitPrice && this.allWeight) {
        lowTotal = parseFloat(lowTotal) + Number(this.toFixed(parseFloat(this.goodform.unitPrice) * parseFloat(this.allWeight), 2))
      }
      // console.log(lowTotal)
      return lowTotal
    },
    allP1 () {
      let total1 = 0
      if (this.goodform.unitPrice && this.allWeight) {
        total1 = parseFloat(total1) + Number(this.toFixed(parseFloat(this.goodform.unitPrice) * parseFloat(this.allWeight), 2)) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.serviceFee)
      }
      // console.log(total1)
      return total1
    },
    allP2 () {
      let total1 = 0
      if (this.goodform.unitPrice) {
        total1 = parseFloat(total1) + parseFloat(this.goodform.unitPrice) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.serviceFee)
      }
      // console.log(total1)
      return total1
    }
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    energyTypeChange (val) {
      console.log(val, 'energyTypeChange')
      this.energyTypeList = []
      val.forEach(item => {
        console.log(this.energyTypeOptions.find(item1 => item1.energyName === item), '878')
        this.energyTypeList.push(this.energyTypeOptions.find(item1 => item1.energyName === item))
      })
      console.log(this.energyTypeList, 'this.energyTypeList')
    },
    standardsChange (val) {
      console.log(val, 'standardsChange')
      this.emissionStandardList = []
      val.forEach(item => {
        console.log(this.pfbz.find(item1 => item1.name === item))
        this.emissionStandardList.push(this.pfbz.find(item1 => item1.name === item))
      })
      console.log(this.emissionStandardList)
    },
    RchangeDateFn () {
      if (this.goodform.demandFinalDate) {
        // var t = new Date()
        // console.log(t.getTime())
        console.log(this.goodform.demandFinalDate)
        console.log(dateFormatUtil('yyyy-MM-dd hh:ii:ss', (new Date())))

        if (this.goodform.demandFinalDate < dateFormatUtil('yyyy-MM-dd hh:ii', (new Date()))) {
          this.$alert('有效期至应大于当前系统时间!', '系统提示')
          this.$set(this.goodform, 'demandFinalDate', '')
        }
      }

      if (this.goodform.hopeReceivingDate) {
        if (this.goodform.hopeReceivingDate < dateFormatUtil('yyyy-MM-dd hh:ii', (new Date()))) {
          this.$alert('最晚提货时间应大于当前系统时间!', '系统提示')
          this.$set(this.goodform, 'hopeReceivingDate', '')
        }
      }
    },

    // 选择车队
    selectFleetFn () {
      selectTenantLongCarriageList({ businessType: 2, targetType: 1 }).then(res => {
        this.sDemandOfferList = res
        this.rowSelectFlag = true
        this.multipleSelection.forEach(row => {
          this.$nextTick(() => {
            this.$refs.CDtable.toggleRowSelection(this.sDemandOfferList.find(item => {
              return row.id === item.id
            }), true)
          })
        })
        this.rowSelectFlag = false
      })
      this.isEdit = true
    },
    handleSelectionChange (val) {
      if (this.rowSelectFlag) return
      console.log(val, '000')
      this.multipleSelection = val
    },
    // 获取row的key值
    getRowKeys (row) {
      return row.id
    },
    // 删除车队标签
    handleClose (tag) {
      // this.multipleSelection.splice(index, 1)
      // console.log(this.multipleSelection.indexOf(tag), tag)
      this.multipleSelection.splice(this.multipleSelection.indexOf(tag), 1)
    },
    fleetFN () {
      console.log(this.multipleSelection, '001')
      this.isEdit = false
    },
    shuomingFn () {
      this.shuomingFlag = true
    },
    priceChange () {
      if (this.goodform.lowPrice && this.goodform.highPrice) {
        this.goodform.lowPrice = ''
        this.goodform.highPrice = ''
        return
      }
      // 杂费
      if (this.goodform.incidental) {
        this.goodform.incidental = ''
        return
      }
      if (this.goodform.unitPrice) {
        this.goodform.unitPrice = ''
      }
    },
    rangeChange () {
      // this.$set(this.goodform, 'publishScopeType', 1)
      console.log(this.goodform.publishScopeType + '切换')
    },
    effectiveTime () {
      if (this.goodform.triggerDuration > 48) {
        this.$alert('有效时长不大于48小时！', '系统提示')
      }
      if (this.goodform.markupInterval > 60) {
        this.$alert('加价间隔时间不大于60分钟！', '系统提示')
      }
    },

    totalFN () {
      this.charge = true
    },
    closeDialog () {

      // this.multipleSelection = []
      // this.$refs.CDtable.clearSelection()
    },

    destroy () {
      this.importDialog = false
      this.dialogXzdz = false
      this.shuomingFlag = false
    },
    // 发布
    saveFn (formName, n) {
      console.log(this.goodform.highPrice, this.goodform.lowPrice)
      if (!this.islook) {
        this.$alert('请阅读【找车说明】', '系统提示')
        return
      }
      if (this.multipleSelection.length == 0) {
        this.$alert('请选择指定承运商！', '系统提示')
        return
      }
      if (this.multipleSelection.length < 2 && (this.goodform.demandType == 1 || this.goodform.demandType == 2)) {
        this.$alert('指定承运商不能小于两个！', '系统提示')
        return
      }
      if (this.goodform.demandType == 2 && this.goodform.unitPrice === '0') {
        this.$alert('价格不能输入0！', '系统提示')
        return
      }
      if (this.goodform.demandType == 1) {
        if (this.goodform.lowPrice === '0' || this.goodform.highPrice === '0') {
          this.$alert('限价不能输入0！', '系统提示')
          return
        }
        if (parseFloat(this.goodform.lowPrice) >= parseFloat(this.goodform.highPrice)) {
          this.$alert('最高限价不得小于等于最低限价！', '系统提示')
          return
        }
      }
      if (Number(this.toFixed(parseFloat(this.goodform.unitPrice) + parseFloat(this.goodform.markupAmount), 2)) > this.goodform.markupHighAmount) {
        this.$alert('最高限价应大于等于包干价+加价间隔金额总和！', '系统提示')
        return
      }
      console.log(this.goodform.triggerStatus + '999')
      if (this.goodform.triggerStartDate) {
        let aaT = this.goodform.triggerStartDate.substring(0, 2)
        this.$set(this.goodform, 'triggerStartDate', aaT)
      }

      this.$set(this.goodform, 'serviceFee', this.serviceFee)

      let arr = []
      this.multipleSelection.map((item, index) => {
        let tt = {
          carriageType: item.targetType,
          carriageCode: item.targetTenantCode,
          carriageName: item.targetTenantName,
          carriageCustomerTaxId: '',
          carriageTelephone: ''
        }
        arr[index] = tt
      })
      console.log(arr, 'arr')
      delete this.goodform.standardsName
      delete this.goodform.energyName
      let addForm = {
        sVirtualBillExt: {
          janFaFlag: this.janFaFlag
        },
        sDemand: { ...this.goodform },
        sDemandOfferList: arr,
        sVirtualGoods: this.goodform.options,
        emissionStandardList: this.emissionStandardList,
        energyTypeList: this.energyTypeList
      }
      console.log(addForm)

      if (this.goodform.triggerStatus == false) {
        addForm.sDemand.triggerStatus = 1
      } else {
        addForm.sDemand.triggerStatus = 2
      }
      console.log(addForm, this.goodform, 'addForm')

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fbLoad = true
          addForFindCar(addForm).then(res => {
            console.log(res)
            if (this.imgList.length > 0) {
              this.saveFN2(res.demand.id)
            } else {
              this.$router.push({ name: 'searchCarJY' })
              this.fbLoad = false
            }
          }).catch(error => {
            this.$message.error(error.message)
            this.fbLoad = false
          })
        }
      })
    },
    async saveFN2 (id) {
      let params = new FormData()
      for (var i = 0; i < this.imgList.length; i++) {
        let result = await compressImage(this.imgList[i].url, this.imgList[i].raw, {
          width: 1000
        })
        params.append('files', result)
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addSDemandFile(params, id).then(res => {
        loading.close()
        this.$router.push({ name: 'searchCarJY' })
        this.fbLoad = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
        this.fbLoad = false
      })
    },
    // 图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
      this.imgList = fileList
      if (fileList.length < 5) {
        this.isAdd = false
      }
    },
    imgPreview (file, fileList) {
      console.log(file, fileList)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        this.imgList = fileList
        if (fileList.length < 5) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
      console.log(this.dialogImageUrl)
    },
    // 选择地址
    addxzdzFn (n) {
      this.addressType = n
      this.dialogXzdz = true
    },
    handleCurrentChange (val) {
      this.currentRow = val
      this.dialogXzdz = false
      if (this.addressType == 1) {
        this.$set(this.goodform, 'receivingPerson', this.currentRow.person)
        this.$set(this.goodform, 'receivingPhone', this.currentRow.phone)
        this.$set(this.goodform, 'receivingAddress', this.currentRow.name)
        this.goodform.receivingProvinceCode = this.currentRow.provinceCode
        this.goodform.receivingCityCode = this.currentRow.cityCode
        this.goodform.receivingAreaCode = this.currentRow.areaCode
        this.goodform.receivingProvinceName = this.currentRow.provinceName
        this.goodform.receivingCityName = this.currentRow.cityName
        this.goodform.receivingAreaName = this.currentRow.areaName
        this.goodform.receivingAddressId = this.currentRow.id
        this.goodform.receivingLongitude = this.currentRow.longitude
        this.goodform.receivingLatitude = this.currentRow.latitude
      } else {
        this.$set(this.goodform, 'deliverPerson', this.currentRow.person)
        this.$set(this.goodform, 'deliverPhone', this.currentRow.phone)
        this.$set(this.goodform, 'deliverAddress', this.currentRow.name)
        this.goodform.deliverProvinceCode = this.currentRow.provinceCode
        this.goodform.deliverCityCode = this.currentRow.cityCode
        this.goodform.deliverAreaCode = this.currentRow.areaCode
        this.goodform.deliverProvinceName = this.currentRow.provinceName
        this.goodform.deliverCityName = this.currentRow.cityName
        this.goodform.deliverAreaName = this.currentRow.areaName
        this.goodform.deliverAddressId = this.currentRow.id
        this.goodform.deliverLongitude = this.currentRow.longitude
        this.goodform.deliverLatitude = this.currentRow.latitude
      }
      this.$refs.goodform.clearValidate()
    }
  }
}
</script>

<style scoped lang='less'>
.imgBox {
  margin: 22px 60px;
}

.hidden /deep/.el-upload--picture-card {
  display: none;
}
.danweiBox {
  /deep/.el-input {
    width: auto;
  }
  /deep/.el-select {
    width: 60px;
    .el-input__inner {
      width: 60px;
    }
  }
}
// /deep/ .el-table__body-wrapper is-scrolling-left {
//   overflow-y: auto;
// }
/deep/.jiaoyan1 .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.styl {
  margin-left: 10px;
  color: #333;
  font-size: 14px;
}
.jiage .el-form-item__content {
  position: relative;
  .danwei1 {
    position: absolute;
    right: 4px;
    color: #9c9797;
    padding: 0px 4px;
  }
  .danwei2 {
    position: absolute;
    right: 4px;
    color: #9c9797;
    padding: 0px 4px;
  }
}
.jiage1 .el-form-item__content {
  position: relative;
  .danwei1 {
    position: absolute;
    right: 4px;
    color: #9c9797;
    padding: 0px 4px;
  }
  .danwei2 {
    position: absolute;
    right: 4px;
    color: #9c9797;
    padding: 0px 4px;
  }
}
/deep/.jiage1 .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.price {
  display: flex;
  flex-direction: row;
  height: 28px;
}
.total {
  color: #333;
  font-size: 14px;
}
table {
  width: 100%;
  height: 25%;
  td {
    padding: 8px 10px;
    text-align: center;
  }
}
.footer {
  margin-top: 20px;
}
/deep/.inpBox1 .el-input__inner {
  width: 180px;
}
/deep/.inpBox2 .el-input__inner {
  width: 150px;
}
/deep/.el-tag {
  margin-right: 10px;
}
/deep/.shuoming {
  margin: 20px 564px;
}
/deep/.el-checkbox__inner {
  width: 18px;
  height: 18px;
}
/deep/.el-checkbox__inner::after {
  height: 9px;
  left: 6px;
  top: 1px;
}
/deep/.inpBox3 .el-input__inner {
  width: 300px;
}
</style>
